export default __webpack_public_path__ + "static/media/promo-how-far-will-fudge-go_00.d1f42a82.jpg";